import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { CompanyApi } from "../../../../apis/company";
import { useFetchCompanyDetails } from "../../../../data/fetch-hooks";
import { shouldShowErrorModal } from "../../../../lib/errorUtils";
export function useTaxClassificationChangeNotice() {
    var _companyDetails_companyDetails_companyDetailRecord, _companyDetails_companyDetails;
    const { data: companyDetails = {} } = useFetchCompanyDetails();
    const queryClient = useQueryClient();
    const [showTaxChangeModal, setShowTaxChangeModal] = useState(false);
    const [showError, setShowError] = useState(false);
    const taxChangeNoticeType = companyDetails === null || companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails = companyDetails.companyDetails) === null || _companyDetails_companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails_companyDetailRecord = _companyDetails_companyDetails.companyDetailRecord) === null || _companyDetails_companyDetails_companyDetailRecord === void 0 ? void 0 : _companyDetails_companyDetails_companyDetailRecord.tax_classification_change_notice_type;
    useEffect(()=>{
        var _companyDetails_companyDetails_companyDetailRecord, _companyDetails_companyDetails;
        const hasPendingNotice = Boolean(companyDetails === null || companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails = companyDetails.companyDetails) === null || _companyDetails_companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails_companyDetailRecord = _companyDetails_companyDetails.companyDetailRecord) === null || _companyDetails_companyDetails_companyDetailRecord === void 0 ? void 0 : _companyDetails_companyDetails_companyDetailRecord.tax_classification_change_notice_pending);
        if (hasPendingNotice && taxChangeNoticeType) {
            setShowTaxChangeModal(true);
            queryClient.invalidateQueries({
                queryKey: [
                    "products"
                ]
            });
        }
    }, [
        companyDetails,
        taxChangeNoticeType,
        queryClient
    ]);
    const handleCloseTaxChangeModal = async ()=>{
        setShowTaxChangeModal(false);
        try {
            await CompanyApi.acknowledgeTaxClassificationChange();
            queryClient.invalidateQueries({
                queryKey: [
                    "company-details"
                ]
            });
        } catch (error) {
            if (shouldShowErrorModal(error)) {
                setShowError(true);
            }
        }
    };
    return {
        showTaxChangeModal,
        taxChangeNoticeType,
        handleCloseTaxChangeModal,
        showError,
        setShowError
    };
}
